import { render, staticRenderFns } from "./FormularioEstacaoTrabalho.vue?vue&type=template&id=496a44de&scoped=true&"
import script from "./FormularioEstacaoTrabalho.vue?vue&type=script&lang=js&"
export * from "./FormularioEstacaoTrabalho.vue?vue&type=script&lang=js&"
import style0 from "./FormularioEstacaoTrabalho.vue?vue&type=style&index=0&id=496a44de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496a44de",
  null
  
)

export default component.exports